// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AcceptInvitationApiV1OrganizationsOrgIdMembersAcceptInvitePostData, AcceptInvitationApiV1OrganizationsOrgIdMembersAcceptInvitePostErrors, AcceptInvitationApiV1OrganizationsOrgIdMembersAcceptInvitePostResponses, ActivateUserApiV1UsersUserIdActivatePostData, ActivateUserApiV1UsersUserIdActivatePostErrors, ActivateUserApiV1UsersUserIdActivatePostResponses, AnalyzeProductContentApiV1GenerationsOrgIdValidateProductProductProductIdPostData, AnalyzeProductContentApiV1GenerationsOrgIdValidateProductProductProductIdPostErrors, AnalyzeProductContentApiV1GenerationsOrgIdValidateProductProductProductIdPostResponses, AnalyzeProductContentCompetitionApiV1GenerationsOrgIdValidateProductCompetitionPostData, AnalyzeProductContentCompetitionApiV1GenerationsOrgIdValidateProductCompetitionPostErrors, AnalyzeProductContentCompetitionApiV1GenerationsOrgIdValidateProductCompetitionPostResponses, ApplyPromoCodeApiV1BillingOrgIdBillingPromoApplyPostData, ApplyPromoCodeApiV1BillingOrgIdBillingPromoApplyPostErrors, ApplyPromoCodeApiV1BillingOrgIdBillingPromoApplyPostResponses, CancelGenerationEndpointApiV1GenerationsGenerationGenerationIdCancelPostData, CancelGenerationEndpointApiV1GenerationsGenerationGenerationIdCancelPostErrors, CancelGenerationEndpointApiV1GenerationsGenerationGenerationIdCancelPostResponses, CancelSubscriptionApiV1BillingOrgIdBillingSubscriptionCancelPostData, CancelSubscriptionApiV1BillingOrgIdBillingSubscriptionCancelPostErrors, CancelSubscriptionApiV1BillingOrgIdBillingSubscriptionCancelPostResponses, ChangeEmailApiV1AuthChangeEmailPostData, ChangeEmailApiV1AuthChangeEmailPostErrors, ChangeEmailApiV1AuthChangeEmailPostResponses, ChangePasswordApiV1AuthChangePasswordPostData, ChangePasswordApiV1AuthChangePasswordPostErrors, ChangePasswordApiV1AuthChangePasswordPostResponses, CheckCanAffordApiV1BillingOrgIdBillingCanAffordTokenCostGetData, CheckCanAffordApiV1BillingOrgIdBillingCanAffordTokenCostGetErrors, CheckCanAffordApiV1BillingOrgIdBillingCanAffordTokenCostGetResponses, CheckUserEligibilityApiV1OrganizationsOrgIdMembersCheckEligibilityPostData, CheckUserEligibilityApiV1OrganizationsOrgIdMembersCheckEligibilityPostErrors, CheckUserEligibilityApiV1OrganizationsOrgIdMembersCheckEligibilityPostResponses, ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostData, ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostErrors, ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostResponses, CreateGenerationFeedbackApiV1GenerationsGenerationGenerationIdFeedbackPostData, CreateGenerationFeedbackApiV1GenerationsGenerationGenerationIdFeedbackPostErrors, CreateGenerationFeedbackApiV1GenerationsGenerationGenerationIdFeedbackPostResponses, CreateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsPostData, CreateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsPostErrors, CreateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsPostResponses, CreateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsGetData, CreateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsGetErrors, CreateOrganizationApiV1OrganizationsPostData, CreateOrganizationApiV1OrganizationsPostErrors, CreateOrganizationApiV1OrganizationsPostResponses, CreateProductBrandApiV1ProductsOrgIdBrandsPostData, CreateProductBrandApiV1ProductsOrgIdBrandsPostErrors, CreateProductBrandApiV1ProductsOrgIdBrandsPostResponses, CreateProjectProductApiV1ProductsOrgIdCreatePostData, CreateProjectProductApiV1ProductsOrgIdCreatePostErrors, CreateProjectProductApiV1ProductsOrgIdCreatePostResponses, CreateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdPostData, CreateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdPostErrors, CreateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdPostResponses, CreateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdPostData, CreateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdPostErrors, CreateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdPostResponses, CreateSupportRequestApiV1SupportSupportRequestsPostData, CreateSupportRequestApiV1SupportSupportRequestsPostErrors, CreateSupportRequestApiV1SupportSupportRequestsPostResponses, DeactivateUserApiV1UsersUserIdDeactivatePostData, DeactivateUserApiV1UsersUserIdDeactivatePostErrors, DeactivateUserApiV1UsersUserIdDeactivatePostResponses, DeleteAssetApiV1AssetsAssetIdDeleteData, DeleteAssetApiV1AssetsAssetIdDeleteErrors, DeleteAssetApiV1AssetsAssetIdDeleteResponses, DeleteOrganizationApiV1OrganizationsOrgIdDeleteData, DeleteOrganizationApiV1OrganizationsOrgIdDeleteErrors, DeleteOrganizationApiV1OrganizationsOrgIdDeleteResponses, DeleteProductApiV1ProductsOrgIdProductsProductIdDeleteData, DeleteProductApiV1ProductsOrgIdProductsProductIdDeleteErrors, DeleteProductApiV1ProductsOrgIdProductsProductIdDeleteResponses, DeleteProductAssetApiV1AssetsOrgIdProductsProductAssetIdDeleteData, DeleteProductAssetApiV1AssetsOrgIdProductsProductAssetIdDeleteErrors, DeleteProductAssetApiV1AssetsOrgIdProductsProductAssetIdDeleteResponses, DeleteProductBrendApiV1ProductsOrgIdBrandsBrendIdDeleteData, DeleteProductBrendApiV1ProductsOrgIdBrandsBrendIdDeleteErrors, DeleteProductBrendApiV1ProductsOrgIdBrandsBrendIdDeleteResponses, DeleteUserApiV1UsersUserIdDeleteData, DeleteUserApiV1UsersUserIdDeleteErrors, DeleteUserApiV1UsersUserIdDeleteResponses, DeleteUserAvatarApiV1OrganizationsOrgIdLogoDeleteDeleteData, DeleteUserAvatarApiV1OrganizationsOrgIdLogoDeleteDeleteErrors, DeleteUserAvatarApiV1OrganizationsOrgIdLogoDeleteDeleteResponses, DeleteUserAvatarApiV1UsersAvatarDeleteDeleteData, DeleteUserAvatarApiV1UsersAvatarDeleteDeleteResponses, DownloadAssetApiV1AssetsAssetIdDownloadGetData, DownloadAssetApiV1AssetsAssetIdDownloadGetErrors, DownloadAssetApiV1AssetsAssetIdDownloadGetResponses, GenerateHpImageApiV1GenerationsOrgIdGenerateHpImageProductProductIdPostData, GenerateHpImageApiV1GenerationsOrgIdGenerateHpImageProductProductIdPostErrors, GenerateHpImageApiV1GenerationsOrgIdGenerateHpImageProductProductIdPostResponses, GenerateIgImageApiV1GenerationsOrgIdGenerateIgImageProductProductIdPostData, GenerateIgImageApiV1GenerationsOrgIdGenerateIgImageProductProductIdPostErrors, GenerateIgImageApiV1GenerationsOrgIdGenerateIgImageProductProductIdPostResponses, GenerateImagesApiV1GenerationsOrgIdGenerateImagesProductProductIdPostData, GenerateImagesApiV1GenerationsOrgIdGenerateImagesProductProductIdPostErrors, GenerateImagesApiV1GenerationsOrgIdGenerateImagesProductProductIdPostResponses, GenerateLsImageApiV1GenerationsOrgIdGenerateLsImageProductProductIdPostData, GenerateLsImageApiV1GenerationsOrgIdGenerateLsImageProductProductIdPostErrors, GenerateLsImageApiV1GenerationsOrgIdGenerateLsImageProductProductIdPostResponses, GenerateLsPromptApiV1GenerationsOrgIdGenerateLsPromptProductProductIdPostData, GenerateLsPromptApiV1GenerationsOrgIdGenerateLsPromptProductProductIdPostErrors, GenerateLsPromptApiV1GenerationsOrgIdGenerateLsPromptProductProductIdPostResponses, GenerateProductGroupImagesApiV1GenerationsOrgIdGenerateGroupImagesProductProductIdPostData, GenerateProductGroupImagesApiV1GenerationsOrgIdGenerateGroupImagesProductProductIdPostErrors, GenerateProductGroupImagesApiV1GenerationsOrgIdGenerateGroupImagesProductProductIdPostResponses, GenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPostData, GenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPostErrors, GenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPostResponses, GenerationScoreStatsApiV1StatsOrgIdScoresGetData, GenerationScoreStatsApiV1StatsOrgIdScoresGetErrors, GenerationScoreStatsApiV1StatsOrgIdScoresGetResponses, GenerationSegmentScoreStatsApiV1StatsOrgIdSegmentScoresGetData, GenerationSegmentScoreStatsApiV1StatsOrgIdSegmentScoresGetErrors, GenerationSegmentScoreStatsApiV1StatsOrgIdSegmentScoresGetResponses, GetActiveCeleryTasksApiV1CeleryActiveTasksGetData, GetActiveCeleryTasksApiV1CeleryActiveTasksGetResponses, GetAssetApiV1AssetsAssetIdGetData, GetAssetApiV1AssetsAssetIdGetErrors, GetAssetApiV1AssetsAssetIdGetResponses, GetAssetsApiV1AssetsGetData, GetAssetsApiV1AssetsGetErrors, GetAssetsApiV1AssetsGetResponses, GetAssetsStatsApiV1AssetsStatsSummaryGetData, GetAssetsStatsApiV1AssetsStatsSummaryGetResponses, GetBackgroundRemovalDetailApiV1GenerationsGenerationGenerationIdBackgroundRemovalGetData, GetBackgroundRemovalDetailApiV1GenerationsGenerationGenerationIdBackgroundRemovalGetErrors, GetBackgroundRemovalDetailApiV1GenerationsGenerationGenerationIdBackgroundRemovalGetResponses, GetBackgroundReplacementDetailApiV1GenerationsOrgIdGenerationGenerationIdBackgroundReplacementGetData, GetBackgroundReplacementDetailApiV1GenerationsOrgIdGenerationGenerationIdBackgroundReplacementGetErrors, GetBackgroundReplacementDetailApiV1GenerationsOrgIdGenerationGenerationIdBackgroundReplacementGetResponses, GetCardValidationDetailApiV1GenerationsOrgIdGenerationGenerationIdCardValidationGetData, GetCardValidationDetailApiV1GenerationsOrgIdGenerationGenerationIdCardValidationGetErrors, GetCardValidationDetailApiV1GenerationsOrgIdGenerationGenerationIdCardValidationGetResponses, GetCeleryStatsApiV1CeleryStatsGetData, GetCeleryStatsApiV1CeleryStatsGetResponses, GetCeleryTaskStatusApiV1CeleryTaskTaskIdGetData, GetCeleryTaskStatusApiV1CeleryTaskTaskIdGetErrors, GetCeleryTaskStatusApiV1CeleryTaskTaskIdGetResponses, GetCommonScoresApiV1StatsOrgIdCommonGetData, GetCommonScoresApiV1StatsOrgIdCommonGetErrors, GetCommonScoresApiV1StatsOrgIdCommonGetResponses, GetCurrentUserInfoApiV1AuthMeGetData, GetCurrentUserInfoApiV1AuthMeGetResponses, GetGenerateHpImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateHpImageGetData, GetGenerateHpImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateHpImageGetErrors, GetGenerateHpImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateHpImageGetResponses, GetGenerateIgImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateIgImageGetData, GetGenerateIgImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateIgImageGetErrors, GetGenerateIgImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateIgImageGetResponses, GetGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGetData, GetGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGetErrors, GetGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGetResponses, GetGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGetData, GetGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGetErrors, GetGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGetResponses, GetGenerateLsImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsImageGetData, GetGenerateLsImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsImageGetErrors, GetGenerateLsImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsImageGetResponses, GetGenerateLsPromptDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsPromptGetData, GetGenerateLsPromptDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsPromptGetErrors, GetGenerateLsPromptDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsPromptGetResponses, GetGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGetData, GetGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGetErrors, GetGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGetResponses, GetGenerationCeleryStatusApiV1GenerationsGenerationIdCeleryStatusGetData, GetGenerationCeleryStatusApiV1GenerationsGenerationIdCeleryStatusGetErrors, GetGenerationCeleryStatusApiV1GenerationsGenerationIdCeleryStatusGetResponses, GetGenerationExportApiV1GenerationsOrgIdGenerationGenerationIdExportGetData, GetGenerationExportApiV1GenerationsOrgIdGenerationGenerationIdExportGetErrors, GetGenerationExportApiV1GenerationsOrgIdGenerationGenerationIdExportGetResponses, GetGenerationGroupDetailApiV1GenerationsOrgIdGenerationImageGroupsGenerationGroupIdGetData, GetGenerationGroupDetailApiV1GenerationsOrgIdGenerationImageGroupsGenerationGroupIdGetErrors, GetGenerationGroupDetailApiV1GenerationsOrgIdGenerationImageGroupsGenerationGroupIdGetResponses, GetGenerationRoReExportExcelApiV1GenerationsOrgIdGenerationsExportExcelPostData, GetGenerationRoReExportExcelApiV1GenerationsOrgIdGenerationsExportExcelPostErrors, GetGenerationRoReExportExcelApiV1GenerationsOrgIdGenerationsExportExcelPostResponses, GetGenerationStatsApiV1GenerationsStatsGetData, GetGenerationStatsApiV1GenerationsStatsGetResponses, GetGenerationStatusApiV1GenerationsGenerationGenerationIdStatusGetData, GetGenerationStatusApiV1GenerationsGenerationGenerationIdStatusGetErrors, GetGenerationStatusApiV1GenerationsGenerationGenerationIdStatusGetResponses, GetImageGenerationGroupsApiV1GenerationsOrgIdGenerationImageGroupsProductProductIdGetData, GetImageGenerationGroupsApiV1GenerationsOrgIdGenerationImageGroupsProductProductIdGetErrors, GetImageGenerationGroupsApiV1GenerationsOrgIdGenerationImageGroupsProductProductIdGetResponses, GetImageValidationDetailApiV1GenerationsGenerationGenerationIdImageValidationGetData, GetImageValidationDetailApiV1GenerationsGenerationGenerationIdImageValidationGetErrors, GetImageValidationDetailApiV1GenerationsGenerationGenerationIdImageValidationGetResponses, GetIntegrationByMarketplaceApiV1OrganizationsOrgIdMarketplaceIntegrationsByMarketplaceMarketplaceGetData, GetIntegrationByMarketplaceApiV1OrganizationsOrgIdMarketplaceIntegrationsByMarketplaceMarketplaceGetErrors, GetIntegrationByMarketplaceApiV1OrganizationsOrgIdMarketplaceIntegrationsByMarketplaceMarketplaceGetResponses, GetInvitationInfoApiV1OrganizationsInvitationsTokenGetData, GetInvitationInfoApiV1OrganizationsInvitationsTokenGetErrors, GetInvitationInfoApiV1OrganizationsInvitationsTokenGetResponses, GetMarketplaceExamplesApiV1MarketplaceExamplesGetData, GetMarketplaceExamplesApiV1MarketplaceExamplesGetErrors, GetMarketplaceExamplesApiV1MarketplaceExamplesGetResponses, GetMarketplaceIntegrationsApiV1OrganizationsOrgIdMarketplaceIntegrationsGetData, GetMarketplaceIntegrationsApiV1OrganizationsOrgIdMarketplaceIntegrationsGetErrors, GetMarketplaceIntegrationsApiV1OrganizationsOrgIdMarketplaceIntegrationsGetResponses, GetMyOrganizationsApiV1OrganizationsMyGetData, GetMyOrganizationsApiV1OrganizationsMyGetErrors, GetMyOrganizationsApiV1OrganizationsMyGetResponses, GetMyProfileApiV1UsersMeGetData, GetMyProfileApiV1UsersMeGetResponses, GetOrganizationApiV1OrganizationsOrgIdGetData, GetOrganizationApiV1OrganizationsOrgIdGetErrors, GetOrganizationApiV1OrganizationsOrgIdGetResponses, GetOrganizationMembersApiV1OrganizationsOrgIdMembersGetData, GetOrganizationMembersApiV1OrganizationsOrgIdMembersGetErrors, GetOrganizationMembersApiV1OrganizationsOrgIdMembersGetResponses, GetOrganizationStatsApiV1OrganizationsOrgIdStatsGetData, GetOrganizationStatsApiV1OrganizationsOrgIdStatsGetErrors, GetOrganizationStatsApiV1OrganizationsOrgIdStatsGetResponses, GetOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGetData, GetOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGetErrors, GetOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGetResponses, GetPaymentsHistoryApiV1BillingOrgIdBillingPaymentsGetData, GetPaymentsHistoryApiV1BillingOrgIdBillingPaymentsGetErrors, GetPaymentsHistoryApiV1BillingOrgIdBillingPaymentsGetResponses, GetPendingInvitationsApiV1OrganizationsOrgIdMembersPendingGetData, GetPendingInvitationsApiV1OrganizationsOrgIdMembersPendingGetErrors, GetPendingInvitationsApiV1OrganizationsOrgIdMembersPendingGetResponses, GetProductAssetsApiV1AssetsOrgIdProductsProductIdGetData, GetProductAssetsApiV1AssetsOrgIdProductsProductIdGetErrors, GetProductAssetsApiV1AssetsOrgIdProductsProductIdGetResponses, GetProductBrendApiV1ProductsOrgIdBrandsBrendIdGetData, GetProductBrendApiV1ProductsOrgIdBrandsBrendIdGetErrors, GetProductBrendApiV1ProductsOrgIdBrandsBrendIdGetResponses, GetProductBrendsApiV1ProductsOrgIdBrandsGetData, GetProductBrendsApiV1ProductsOrgIdBrandsGetErrors, GetProductBrendsApiV1ProductsOrgIdBrandsGetResponses, GetProductDetailApiV1ProductsOrgIdProductsProductIdGetData, GetProductDetailApiV1ProductsOrgIdProductsProductIdGetErrors, GetProductDetailApiV1ProductsOrgIdProductsProductIdGetResponses, GetProductGenerationsApiV1GenerationsOrgIdProductProductIdGetData, GetProductGenerationsApiV1GenerationsOrgIdProductProductIdGetErrors, GetProductGenerationsApiV1GenerationsOrgIdProductProductIdGetResponses, GetProductSellersApiV1ProductsOrgIdSellersGetData, GetProductSellersApiV1ProductsOrgIdSellersGetErrors, GetProductSellersApiV1ProductsOrgIdSellersGetResponses, GetProductsListApiV1ProductsOzonListIntegrationIdGetData, GetProductsListApiV1ProductsOzonListIntegrationIdGetErrors, GetProductsListApiV1ProductsOzonListIntegrationIdGetResponses, GetProductsScoresApiV1StatsOrgIdProductsScoresGetData, GetProductsScoresApiV1StatsOrgIdProductsScoresGetErrors, GetProductsScoresApiV1StatsOrgIdProductsScoresGetResponses, GetProjectProductsApiV1ProductsOrgIdListGetData, GetProjectProductsApiV1ProductsOrgIdListGetErrors, GetProjectProductsApiV1ProductsOrgIdListGetResponses, GetSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGetData, GetSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGetErrors, GetSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGetResponses, GetSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGetData, GetSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGetErrors, GetSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGetResponses, GetSubscriptionInfoApiV1CloudpaymentsSubscribeInfoGetData, GetSubscriptionInfoApiV1CloudpaymentsSubscribeInfoGetErrors, GetSubscriptionInfoApiV1CloudpaymentsSubscribeInfoGetResponses, GetSupportRequestApiV1SupportSupportRequestsSupportRequestIdGetData, GetSupportRequestApiV1SupportSupportRequestsSupportRequestIdGetErrors, GetSupportRequestApiV1SupportSupportRequestsSupportRequestIdGetResponses, GetSupportRequestsApiV1SupportSupportRequestsGetData, GetSupportRequestsApiV1SupportSupportRequestsGetErrors, GetSupportRequestsApiV1SupportSupportRequestsGetResponses, GetThumbnailApiV1AssetsAssetIdThumbnailGetData, GetThumbnailApiV1AssetsAssetIdThumbnailGetErrors, GetThumbnailApiV1AssetsAssetIdThumbnailGetResponses, GetTokenTransactionsApiV1BillingOrgIdBillingTransactionsGetData, GetTokenTransactionsApiV1BillingOrgIdBillingTransactionsGetErrors, GetTokenTransactionsApiV1BillingOrgIdBillingTransactionsGetResponses, GetTopBottomProductsApiV1StatsOrgIdProductsGetData, GetTopBottomProductsApiV1StatsOrgIdProductsGetErrors, GetTopBottomProductsApiV1StatsOrgIdProductsGetResponses, GetUserApiV1UsersUserIdGetData, GetUserApiV1UsersUserIdGetErrors, GetUserApiV1UsersUserIdGetResponses, GetUsersApiV1UsersGetData, GetUsersApiV1UsersGetErrors, GetUsersApiV1UsersGetResponses, GetWbProductsApiV1ProductsWildberriesListIntegrationIdGetData, GetWbProductsApiV1ProductsWildberriesListIntegrationIdGetErrors, GetWbProductsApiV1ProductsWildberriesListIntegrationIdGetResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, InviteMemberApiV1OrganizationsOrgIdMembersInvitePostData, InviteMemberApiV1OrganizationsOrgIdMembersInvitePostErrors, InviteMemberApiV1OrganizationsOrgIdMembersInvitePostResponses, LeaveOrganizationApiV1OrganizationsOrgIdLeavePostData, LeaveOrganizationApiV1OrganizationsOrgIdLeavePostErrors, LeaveOrganizationApiV1OrganizationsOrgIdLeavePostResponses, LoginApiV1AuthLoginPostData, LoginApiV1AuthLoginPostErrors, LoginApiV1AuthLoginPostResponses, LoginApiV1AuthOzonLoginGetData, LoginCallbackApiV1AuthOzonLoginCallbackGetData, LoginCallbackApiV1AuthOzonLoginCallbackGetResponses, LogoutApiV1AuthLogoutPostData, LogoutApiV1AuthLogoutPostResponses, MarketplaceOauthIntegrationCallbackApiV1OrganizationsMarketplaceOauthIntegrationsCallbackGetData, MarketplaceOauthIntegrationCallbackApiV1OrganizationsMarketplaceOauthIntegrationsCallbackGetResponses, ModifyImagesApiV1GenerationsOrgIdModifyImagesProductProductIdPostData, ModifyImagesApiV1GenerationsOrgIdModifyImagesProductProductIdPostErrors, ModifyImagesApiV1GenerationsOrgIdModifyImagesProductProductIdPostResponses, OpenaiWebhookResponseApiV1AiOpenaiWebhookResponsePostData, OpenaiWebhookResponseApiV1AiOpenaiWebhookResponsePostResponses, OptimizeImageApiV1AssetsAssetIdOptimizePostData, OptimizeImageApiV1AssetsAssetIdOptimizePostErrors, OptimizeImageApiV1AssetsAssetIdOptimizePostResponses, PurchaseTokensPageApiV1CloudpaymentsPurchaseTokensGetData, PurchaseTokensPageApiV1CloudpaymentsPurchaseTokensGetErrors, PurchaseTokensPageApiV1CloudpaymentsPurchaseTokensGetResponses, RefreshTokenApiV1AuthRefreshPostData, RefreshTokenApiV1AuthRefreshPostErrors, RefreshTokenApiV1AuthRefreshPostResponses, RegenerateImagesApiV1GenerationsOrgIdRegenerateImagesProductProductIdPostData, RegenerateImagesApiV1GenerationsOrgIdRegenerateImagesProductProductIdPostErrors, RegenerateImagesApiV1GenerationsOrgIdRegenerateImagesProductProductIdPostResponses, RegisterApiV1AuthRegisterPostData, RegisterApiV1AuthRegisterPostErrors, RegisterApiV1AuthRegisterPostResponses, RegisterWithInviteApiV1AuthRegisterWithInvitePostData, RegisterWithInviteApiV1AuthRegisterWithInvitePostErrors, RegisterWithInviteApiV1AuthRegisterWithInvitePostResponses, RemoveMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDeleteData, RemoveMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDeleteErrors, RemoveMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDeleteResponses, ReplicateWebhookPredictionApiV1AiReplicateWebhookPredictionPostData, ReplicateWebhookPredictionApiV1AiReplicateWebhookPredictionPostResponses, RequestPasswordResetApiV1AuthPasswordResetRequestPostData, RequestPasswordResetApiV1AuthPasswordResetRequestPostErrors, RequestPasswordResetApiV1AuthPasswordResetRequestPostResponses, ResendInvitationApiV1OrganizationsOrgIdMembersResendInvitePostData, ResendInvitationApiV1OrganizationsOrgIdMembersResendInvitePostErrors, ResendInvitationApiV1OrganizationsOrgIdMembersResendInvitePostResponses, ResendVerificationApiV1AuthResendVerificationPostData, ResendVerificationApiV1AuthResendVerificationPostErrors, ResendVerificationApiV1AuthResendVerificationPostResponses, RevokeCeleryTaskApiV1CeleryTaskTaskIdRevokePostData, RevokeCeleryTaskApiV1CeleryTaskTaskIdRevokePostErrors, RevokeCeleryTaskApiV1CeleryTaskTaskIdRevokePostResponses, RevokeInvitationApiV1OrganizationsOrgIdInvitationsMembershipIdDeleteData, RevokeInvitationApiV1OrganizationsOrgIdInvitationsMembershipIdDeleteErrors, RevokeInvitationApiV1OrganizationsOrgIdInvitationsMembershipIdDeleteResponses, SpendTokensApiV1BillingOrgIdBillingTokensSpendPostData, SpendTokensApiV1BillingOrgIdBillingTokensSpendPostErrors, SpendTokensApiV1BillingOrgIdBillingTokensSpendPostResponses, SubscriptionPaymentPageApiV1CloudpaymentsSubscribeGetData, SubscriptionPaymentPageApiV1CloudpaymentsSubscribeGetErrors, SubscriptionPaymentPageApiV1CloudpaymentsSubscribeGetResponses, TestMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdTestPostData, TestMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdTestPostErrors, TestMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdTestPostResponses, TransferOwnershipApiV1OrganizationsOrgIdTransferOwnershipPostData, TransferOwnershipApiV1OrganizationsOrgIdTransferOwnershipPostErrors, TransferOwnershipApiV1OrganizationsOrgIdTransferOwnershipPostResponses, UpdateGenerationGroupApiV1GenerationsOrgIdGenerationGroupsGenerationGroupIdPutData, UpdateGenerationGroupApiV1GenerationsOrgIdGenerationGroupsGenerationGroupIdPutErrors, UpdateGenerationGroupApiV1GenerationsOrgIdGenerationGroupsGenerationGroupIdPutResponses, UpdateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdPutData, UpdateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdPutErrors, UpdateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdPutResponses, UpdateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsIntegrationIdGetData, UpdateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsIntegrationIdGetErrors, UpdateMemberRoleApiV1OrganizationsOrgIdMembersUserIdRolePutData, UpdateMemberRoleApiV1OrganizationsOrgIdMembersUserIdRolePutErrors, UpdateMemberRoleApiV1OrganizationsOrgIdMembersUserIdRolePutResponses, UpdateMyProfileApiV1UsersMePutData, UpdateMyProfileApiV1UsersMePutErrors, UpdateMyProfileApiV1UsersMePutResponses, UpdateOrganizationApiV1OrganizationsOrgIdPutData, UpdateOrganizationApiV1OrganizationsOrgIdPutErrors, UpdateOrganizationApiV1OrganizationsOrgIdPutResponses, UpdateProductApiV1ProductsOrgIdProductsProductIdPutData, UpdateProductApiV1ProductsOrgIdProductsProductIdPutErrors, UpdateProductApiV1ProductsOrgIdProductsProductIdPutResponses, UpdateProductBrendApiV1ProductsOrgIdBrandsBrendIdPutData, UpdateProductBrendApiV1ProductsOrgIdBrandsBrendIdPutErrors, UpdateProductBrendApiV1ProductsOrgIdBrandsBrendIdPutResponses, UpdateProductsApiV1MarketplaceOzonUpdateProductsIntegrationIdPostData, UpdateProductsApiV1MarketplaceOzonUpdateProductsIntegrationIdPostErrors, UpdateProductsApiV1MarketplaceOzonUpdateProductsIntegrationIdPostResponses, UpdateProductsApiV1MarketplaceWildberriesUpdateProductsIntegrationIdPostData, UpdateProductsApiV1MarketplaceWildberriesUpdateProductsIntegrationIdPostErrors, UpdateProductsApiV1MarketplaceWildberriesUpdateProductsIntegrationIdPostResponses, UpdateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdUpdatePostData, UpdateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdUpdatePostErrors, UpdateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdUpdatePostResponses, UpdateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdUpdatePostData, UpdateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdUpdatePostErrors, UpdateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdUpdatePostResponses, UpdateUserApiV1UsersUserIdPutData, UpdateUserApiV1UsersUserIdPutErrors, UpdateUserApiV1UsersUserIdPutResponses, UploadAvatarApiV1UsersAvatarUploadPostData, UploadAvatarApiV1UsersAvatarUploadPostErrors, UploadAvatarApiV1UsersAvatarUploadPostResponses, UploadFileApiV1AssetsUploadPostData, UploadFileApiV1AssetsUploadPostErrors, UploadFileApiV1AssetsUploadPostResponses, UploadLogoApiV1OrganizationsOrgIdLogoUploadPostData, UploadLogoApiV1OrganizationsOrgIdLogoUploadPostErrors, UploadLogoApiV1OrganizationsOrgIdLogoUploadPostResponses, UploadProductAssetApiV1AssetsOrgIdProductsProductIdPostData, UploadProductAssetApiV1AssetsOrgIdProductsProductIdPostErrors, UploadProductAssetApiV1AssetsOrgIdProductsProductIdPostResponses, ValidateInvitationTokenApiV1OrganizationsInvitationsTokenValidateGetData, ValidateInvitationTokenApiV1OrganizationsInvitationsTokenValidateGetErrors, ValidateInvitationTokenApiV1OrganizationsInvitationsTokenValidateGetResponses, ValidateResetTokenApiV1AuthPasswordResetValidatePostData, ValidateResetTokenApiV1AuthPasswordResetValidatePostErrors, ValidateResetTokenApiV1AuthPasswordResetValidatePostResponses, VerifyAuthForNginxApiV1AuthVerifyGetData, VerifyAuthForNginxApiV1AuthVerifyGetResponses, VerifyEmailApiV1AuthVerifyEmailPostData, VerifyEmailApiV1AuthVerifyEmailPostErrors, VerifyEmailApiV1AuthVerifyEmailPostResponses, WebhookCheckApiV1CloudpaymentsWebhooksCloudpaymentsCheckPostData, WebhookCheckApiV1CloudpaymentsWebhooksCloudpaymentsCheckPostResponses, WebhookFailApiV1CloudpaymentsWebhooksCloudpaymentsFailPostData, WebhookFailApiV1CloudpaymentsWebhooksCloudpaymentsFailPostResponses, WebhookPayApiV1CloudpaymentsWebhooksCloudpaymentsPayPostData, WebhookPayApiV1CloudpaymentsWebhooksCloudpaymentsPayPostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Login
 *
 * Универсальный вход с проверкой верификации email
 */
export const loginApiV1AuthLoginPost = <ThrowOnError extends boolean = false>(options: Options<LoginApiV1AuthLoginPostData, ThrowOnError>) => (options.client ?? client).post<LoginApiV1AuthLoginPostResponses, LoginApiV1AuthLoginPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Auth For Nginx
 *
 * Эндпоинт для проверки авторизации nginx'ом с проверкой владельца
 */
export const verifyAuthForNginxApiV1AuthVerifyGet = <ThrowOnError extends boolean = false>(options?: Options<VerifyAuthForNginxApiV1AuthVerifyGetData, ThrowOnError>) => (options?.client ?? client).get<VerifyAuthForNginxApiV1AuthVerifyGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/verify',
    ...options
});

/**
 * Register
 *
 * Регистрация нового пользователя с отправкой письма верификации
 */
export const registerApiV1AuthRegisterPost = <ThrowOnError extends boolean = false>(options: Options<RegisterApiV1AuthRegisterPostData, ThrowOnError>) => (options.client ?? client).post<RegisterApiV1AuthRegisterPostResponses, RegisterApiV1AuthRegisterPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Email
 *
 * Подтверждение email по токену
 *
 * В зависимости от настроек может автоматически:
 * - Создать личную организацию пользователя
 * - Начислить триальные токены
 */
export const verifyEmailApiV1AuthVerifyEmailPost = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailApiV1AuthVerifyEmailPostData, ThrowOnError>) => (options.client ?? client).post<VerifyEmailApiV1AuthVerifyEmailPostResponses, VerifyEmailApiV1AuthVerifyEmailPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/verify-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Verification
 *
 * Повторная отправка письма с подтверждением
 */
export const resendVerificationApiV1AuthResendVerificationPost = <ThrowOnError extends boolean = false>(options: Options<ResendVerificationApiV1AuthResendVerificationPostData, ThrowOnError>) => (options.client ?? client).post<ResendVerificationApiV1AuthResendVerificationPostResponses, ResendVerificationApiV1AuthResendVerificationPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/resend-verification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Password Reset
 *
 * Запрос на сброс пароля
 *
 * Отправляет письмо с ссылкой для сброса пароля.
 * В целях безопасности всегда возвращает успех, даже если email не найден.
 */
export const requestPasswordResetApiV1AuthPasswordResetRequestPost = <ThrowOnError extends boolean = false>(options: Options<RequestPasswordResetApiV1AuthPasswordResetRequestPostData, ThrowOnError>) => (options.client ?? client).post<RequestPasswordResetApiV1AuthPasswordResetRequestPostResponses, RequestPasswordResetApiV1AuthPasswordResetRequestPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/password-reset/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate Reset Token
 *
 * Проверка валидности токена сброса пароля
 *
 * Используется фронтендом для проверки токена перед показом формы смены пароля.
 *
 * **Возможные ответы:**
 * - Токен валиден: valid=true + информация о пользователе
 * - Токен истек: valid=false, error="token_expired"
 * - Токен недействителен: valid=false, error="invalid_token"
 * - Аккаунт заблокирован: valid=false, error="account_banned"
 */
export const validateResetTokenApiV1AuthPasswordResetValidatePost = <ThrowOnError extends boolean = false>(options: Options<ValidateResetTokenApiV1AuthPasswordResetValidatePostData, ThrowOnError>) => (options.client ?? client).post<ValidateResetTokenApiV1AuthPasswordResetValidatePostResponses, ValidateResetTokenApiV1AuthPasswordResetValidatePostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/password-reset/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Password Reset
 *
 * Подтверждение сброса пароля
 *
 * Устанавливает новый пароль по токену сброса
 */
export const confirmPasswordResetApiV1AuthPasswordResetConfirmPost = <ThrowOnError extends boolean = false>(options: Options<ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostData, ThrowOnError>) => (options.client ?? client).post<ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostResponses, ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/password-reset/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Token
 *
 * Обновление access токена
 */
export const refreshTokenApiV1AuthRefreshPost = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenApiV1AuthRefreshPostData, ThrowOnError>) => (options.client ?? client).post<RefreshTokenApiV1AuthRefreshPostResponses, RefreshTokenApiV1AuthRefreshPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Current User Info
 *
 * Получение информации о текущем пользователе
 */
export const getCurrentUserInfoApiV1AuthMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserInfoApiV1AuthMeGetData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentUserInfoApiV1AuthMeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options
});

/**
 * Logout
 *
 * Выход - удаляет cookies
 */
export const logoutApiV1AuthLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<LogoutApiV1AuthLogoutPostData, ThrowOnError>) => (options?.client ?? client).post<LogoutApiV1AuthLogoutPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout',
    ...options
});

/**
 * Change Password
 *
 * Смена пароля для авторизованного пользователя
 */
export const changePasswordApiV1AuthChangePasswordPost = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordApiV1AuthChangePasswordPostData, ThrowOnError>) => (options.client ?? client).post<ChangePasswordApiV1AuthChangePasswordPostResponses, ChangePasswordApiV1AuthChangePasswordPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Email
 *
 * Запрос для смены email
 */
export const changeEmailApiV1AuthChangeEmailPost = <ThrowOnError extends boolean = false>(options: Options<ChangeEmailApiV1AuthChangeEmailPostData, ThrowOnError>) => (options.client ?? client).post<ChangeEmailApiV1AuthChangeEmailPostResponses, ChangeEmailApiV1AuthChangeEmailPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/change-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register With Invite
 *
 * Упрощенная регистрация по токену приглашения в организацию
 *
 * Позволяет пользователю зарегистрироваться по токену приглашения,
 * автоматически подтверждает email и добавляет в организацию.
 */
export const registerWithInviteApiV1AuthRegisterWithInvitePost = <ThrowOnError extends boolean = false>(options: Options<RegisterWithInviteApiV1AuthRegisterWithInvitePostData, ThrowOnError>) => (options.client ?? client).post<RegisterWithInviteApiV1AuthRegisterWithInvitePostResponses, RegisterWithInviteApiV1AuthRegisterWithInvitePostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/register-with-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login
 *
 * Обработчик логина через озон
 */
export const loginApiV1AuthOzonLoginGet = <ThrowOnError extends boolean = false>(options?: Options<LoginApiV1AuthOzonLoginGetData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/v1/auth/ozon/login', ...options });

/**
 * Login Callback
 *
 * Обработчик обратного вызова ozon
 */
export const loginCallbackApiV1AuthOzonLoginCallbackGet = <ThrowOnError extends boolean = false>(options?: Options<LoginCallbackApiV1AuthOzonLoginCallbackGetData, ThrowOnError>) => (options?.client ?? client).get<LoginCallbackApiV1AuthOzonLoginCallbackGetResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/auth/ozon/login/callback',
    ...options
});

/**
 * Get My Profile
 *
 * Получение собственного профиля
 */
export const getMyProfileApiV1UsersMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetMyProfileApiV1UsersMeGetData, ThrowOnError>) => (options?.client ?? client).get<GetMyProfileApiV1UsersMeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options
});

/**
 * Update My Profile
 *
 * Обновление собственного профиля
 */
export const updateMyProfileApiV1UsersMePut = <ThrowOnError extends boolean = false>(options: Options<UpdateMyProfileApiV1UsersMePutData, ThrowOnError>) => (options.client ?? client).put<UpdateMyProfileApiV1UsersMePutResponses, UpdateMyProfileApiV1UsersMePutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Users
 *
 * Получение списка пользователей (только для админов)
 */
export const getUsersApiV1UsersGet = <ThrowOnError extends boolean = false>(options?: Options<GetUsersApiV1UsersGetData, ThrowOnError>) => (options?.client ?? client).get<GetUsersApiV1UsersGetResponses, GetUsersApiV1UsersGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/',
    ...options
});

/**
 * Delete User
 *
 * Удаление пользователя (только для админов)
 */
export const deleteUserApiV1UsersUserIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteUserApiV1UsersUserIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserApiV1UsersUserIdDeleteResponses, DeleteUserApiV1UsersUserIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options
});

/**
 * Get User
 *
 * Получение пользователя по ID (только для админов)
 */
export const getUserApiV1UsersUserIdGet = <ThrowOnError extends boolean = false>(options: Options<GetUserApiV1UsersUserIdGetData, ThrowOnError>) => (options.client ?? client).get<GetUserApiV1UsersUserIdGetResponses, GetUserApiV1UsersUserIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options
});

/**
 * Update User
 *
 * Обновление пользователя (только для админов)
 */
export const updateUserApiV1UsersUserIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateUserApiV1UsersUserIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateUserApiV1UsersUserIdPutResponses, UpdateUserApiV1UsersUserIdPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate User
 *
 * Деактивация пользователя
 */
export const deactivateUserApiV1UsersUserIdDeactivatePost = <ThrowOnError extends boolean = false>(options: Options<DeactivateUserApiV1UsersUserIdDeactivatePostData, ThrowOnError>) => (options.client ?? client).post<DeactivateUserApiV1UsersUserIdDeactivatePostResponses, DeactivateUserApiV1UsersUserIdDeactivatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/deactivate',
    ...options
});

/**
 * Activate User
 *
 * Активация пользователя
 */
export const activateUserApiV1UsersUserIdActivatePost = <ThrowOnError extends boolean = false>(options: Options<ActivateUserApiV1UsersUserIdActivatePostData, ThrowOnError>) => (options.client ?? client).post<ActivateUserApiV1UsersUserIdActivatePostResponses, ActivateUserApiV1UsersUserIdActivatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/activate',
    ...options
});

/**
 * Upload Avatar
 *
 * Обновление аватара пользователя
 */
export const uploadAvatarApiV1UsersAvatarUploadPost = <ThrowOnError extends boolean = false>(options: Options<UploadAvatarApiV1UsersAvatarUploadPostData, ThrowOnError>) => (options.client ?? client).post<UploadAvatarApiV1UsersAvatarUploadPostResponses, UploadAvatarApiV1UsersAvatarUploadPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/avatar/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete User Avatar
 */
export const deleteUserAvatarApiV1UsersAvatarDeleteDelete = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserAvatarApiV1UsersAvatarDeleteDeleteData, ThrowOnError>) => (options?.client ?? client).delete<DeleteUserAvatarApiV1UsersAvatarDeleteDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/avatar/delete',
    ...options
});

/**
 * Get Marketplace Integrations
 *
 * Получение всех интеграций организации (только админы и владельцы)
 */
export const getMarketplaceIntegrationsApiV1OrganizationsOrgIdMarketplaceIntegrationsGet = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceIntegrationsApiV1OrganizationsOrgIdMarketplaceIntegrationsGetData, ThrowOnError>) => (options.client ?? client).get<GetMarketplaceIntegrationsApiV1OrganizationsOrgIdMarketplaceIntegrationsGetResponses, GetMarketplaceIntegrationsApiV1OrganizationsOrgIdMarketplaceIntegrationsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/marketplace-integrations',
    ...options
});

/**
 * Create Marketplace Integration
 *
 * Создание новой интеграции с маркетплейсом с валидацией учетных данных
 */
export const createMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsPost = <ThrowOnError extends boolean = false>(options: Options<CreateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsPostData, ThrowOnError>) => (options.client ?? client).post<CreateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsPostResponses, CreateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/marketplace-integrations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Marketplace Integration
 *
 * Обновление интеграции с маркетплейсом с валидацией
 */
export const updateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdPutResponses, UpdateMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/marketplace-integrations/{integration_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test Marketplace Integration
 *
 * Тестирование интеграции с маркетплейсом
 */
export const testMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdTestPost = <ThrowOnError extends boolean = false>(options: Options<TestMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdTestPostData, ThrowOnError>) => (options.client ?? client).post<TestMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdTestPostResponses, TestMarketplaceIntegrationApiV1OrganizationsOrgIdMarketplaceIntegrationsIntegrationIdTestPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/marketplace-integrations/{integration_id}/test',
    ...options
});

/**
 * Get Integration By Marketplace
 *
 * Получение интеграции по типу маркетплейса
 */
export const getIntegrationByMarketplaceApiV1OrganizationsOrgIdMarketplaceIntegrationsByMarketplaceMarketplaceGet = <ThrowOnError extends boolean = false>(options: Options<GetIntegrationByMarketplaceApiV1OrganizationsOrgIdMarketplaceIntegrationsByMarketplaceMarketplaceGetData, ThrowOnError>) => (options.client ?? client).get<GetIntegrationByMarketplaceApiV1OrganizationsOrgIdMarketplaceIntegrationsByMarketplaceMarketplaceGetResponses, GetIntegrationByMarketplaceApiV1OrganizationsOrgIdMarketplaceIntegrationsByMarketplaceMarketplaceGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/marketplace-integrations/by-marketplace/{marketplace}',
    ...options
});

/**
 * Create Marketplace Oauth Integration
 *
 * Создание новой интеграции с маркетплейсом с помощью oauth
 */
export const createMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsGet = <ThrowOnError extends boolean = false>(options: Options<CreateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsGetData, ThrowOnError>) => (options.client ?? client).get<unknown, CreateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/marketplace-oauth-integrations',
    ...options
});

/**
 * Update Marketplace Oauth Integration
 *
 * Обновление интеграции с маркетплейсом с помощью oauth
 */
export const updateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsIntegrationIdGet = <ThrowOnError extends boolean = false>(options: Options<UpdateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsIntegrationIdGetData, ThrowOnError>) => (options.client ?? client).get<unknown, UpdateMarketplaceOauthIntegrationApiV1OrganizationsOrgIdMarketplaceOauthIntegrationsIntegrationIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/marketplace-oauth-integrations/{integration_id}',
    ...options
});

/**
 * Marketplace Oauth Integration Callback
 *
 * Обработчик обратного вызова сервиса аунтификации для интеграции с маркетплейсом с помощью oauth
 */
export const marketplaceOauthIntegrationCallbackApiV1OrganizationsMarketplaceOauthIntegrationsCallbackGet = <ThrowOnError extends boolean = false>(options?: Options<MarketplaceOauthIntegrationCallbackApiV1OrganizationsMarketplaceOauthIntegrationsCallbackGetData, ThrowOnError>) => (options?.client ?? client).get<MarketplaceOauthIntegrationCallbackApiV1OrganizationsMarketplaceOauthIntegrationsCallbackGetResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/organizations/marketplace-oauth-integrations/callback',
    ...options
});

/**
 * Create Organization
 *
 * Создание новой организации
 */
export const createOrganizationApiV1OrganizationsPost = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationApiV1OrganizationsPostData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationApiV1OrganizationsPostResponses, CreateOrganizationApiV1OrganizationsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Organizations
 *
 * Получение всех организаций пользователя с информацией о ролях и фильтрацией
 *
 * Возвращает организации где пользователь:
 * - Является владельцем (роль OWNER)
 * - Является участником (роли ADMIN, MANAGER, MEMBER, VIEWER)
 */
export const getMyOrganizationsApiV1OrganizationsMyGet = <ThrowOnError extends boolean = false>(options?: Options<GetMyOrganizationsApiV1OrganizationsMyGetData, ThrowOnError>) => (options?.client ?? client).get<GetMyOrganizationsApiV1OrganizationsMyGetResponses, GetMyOrganizationsApiV1OrganizationsMyGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/my',
    ...options
});

/**
 * Delete Organization
 *
 * Удаление организации (только владелец)
 */
export const deleteOrganizationApiV1OrganizationsOrgIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationApiV1OrganizationsOrgIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrganizationApiV1OrganizationsOrgIdDeleteResponses, DeleteOrganizationApiV1OrganizationsOrgIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}',
    ...options
});

/**
 * Get Organization
 *
 * Получение информации об организации
 */
export const getOrganizationApiV1OrganizationsOrgIdGet = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationApiV1OrganizationsOrgIdGetData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationApiV1OrganizationsOrgIdGetResponses, GetOrganizationApiV1OrganizationsOrgIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}',
    ...options
});

/**
 * Update Organization
 *
 * Обновление организации (только админы и владелец)
 */
export const updateOrganizationApiV1OrganizationsOrgIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationApiV1OrganizationsOrgIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateOrganizationApiV1OrganizationsOrgIdPutResponses, UpdateOrganizationApiV1OrganizationsOrgIdPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check User Eligibility
 *
 * Проверка возможности приглашения пользователя
 */
export const checkUserEligibilityApiV1OrganizationsOrgIdMembersCheckEligibilityPost = <ThrowOnError extends boolean = false>(options: Options<CheckUserEligibilityApiV1OrganizationsOrgIdMembersCheckEligibilityPostData, ThrowOnError>) => (options.client ?? client).post<CheckUserEligibilityApiV1OrganizationsOrgIdMembersCheckEligibilityPostResponses, CheckUserEligibilityApiV1OrganizationsOrgIdMembersCheckEligibilityPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/members/check-eligibility',
    ...options
});

/**
 * Get Organization Members
 *
 * Получение списка участников организации с пагинацией
 */
export const getOrganizationMembersApiV1OrganizationsOrgIdMembersGet = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationMembersApiV1OrganizationsOrgIdMembersGetData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationMembersApiV1OrganizationsOrgIdMembersGetResponses, GetOrganizationMembersApiV1OrganizationsOrgIdMembersGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/members',
    ...options
});

/**
 * Invite Member
 *
 * Приглашение нового участника в организацию
 */
export const inviteMemberApiV1OrganizationsOrgIdMembersInvitePost = <ThrowOnError extends boolean = false>(options: Options<InviteMemberApiV1OrganizationsOrgIdMembersInvitePostData, ThrowOnError>) => (options.client ?? client).post<InviteMemberApiV1OrganizationsOrgIdMembersInvitePostResponses, InviteMemberApiV1OrganizationsOrgIdMembersInvitePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/members/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Invitation
 *
 * Принятие приглашения в организацию
 */
export const acceptInvitationApiV1OrganizationsOrgIdMembersAcceptInvitePost = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationApiV1OrganizationsOrgIdMembersAcceptInvitePostData, ThrowOnError>) => (options.client ?? client).post<AcceptInvitationApiV1OrganizationsOrgIdMembersAcceptInvitePostResponses, AcceptInvitationApiV1OrganizationsOrgIdMembersAcceptInvitePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/members/accept-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Member Role
 *
 * Изменение роли участника (только админы и владелец)
 */
export const updateMemberRoleApiV1OrganizationsOrgIdMembersUserIdRolePut = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberRoleApiV1OrganizationsOrgIdMembersUserIdRolePutData, ThrowOnError>) => (options.client ?? client).put<UpdateMemberRoleApiV1OrganizationsOrgIdMembersUserIdRolePutResponses, UpdateMemberRoleApiV1OrganizationsOrgIdMembersUserIdRolePutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/members/{user_id}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Member Or Revoke Invite
 *
 * Удаление участника из организации или отзыв приглашения
 */
export const removeMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDelete = <ThrowOnError extends boolean = false>(options: Options<RemoveMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<RemoveMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDeleteResponses, RemoveMemberOrRevokeInviteApiV1OrganizationsOrgIdMembersUserIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/members/{user_id}',
    ...options
});

/**
 * Leave Organization
 *
 * Покинуть организацию
 */
export const leaveOrganizationApiV1OrganizationsOrgIdLeavePost = <ThrowOnError extends boolean = false>(options: Options<LeaveOrganizationApiV1OrganizationsOrgIdLeavePostData, ThrowOnError>) => (options.client ?? client).post<LeaveOrganizationApiV1OrganizationsOrgIdLeavePostResponses, LeaveOrganizationApiV1OrganizationsOrgIdLeavePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/leave',
    ...options
});

/**
 * Transfer Ownership
 *
 * Передача права собственности на организацию (только владелец)
 */
export const transferOwnershipApiV1OrganizationsOrgIdTransferOwnershipPost = <ThrowOnError extends boolean = false>(options: Options<TransferOwnershipApiV1OrganizationsOrgIdTransferOwnershipPostData, ThrowOnError>) => (options.client ?? client).post<TransferOwnershipApiV1OrganizationsOrgIdTransferOwnershipPostResponses, TransferOwnershipApiV1OrganizationsOrgIdTransferOwnershipPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/transfer-ownership',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Organization Stats
 *
 * Получение статистики организации
 */
export const getOrganizationStatsApiV1OrganizationsOrgIdStatsGet = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationStatsApiV1OrganizationsOrgIdStatsGetData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationStatsApiV1OrganizationsOrgIdStatsGetResponses, GetOrganizationStatsApiV1OrganizationsOrgIdStatsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/stats',
    ...options
});

/**
 * Get Invitation Info
 *
 * Получение информации о приглашении по токену
 */
export const getInvitationInfoApiV1OrganizationsInvitationsTokenGet = <ThrowOnError extends boolean = false>(options: Options<GetInvitationInfoApiV1OrganizationsInvitationsTokenGetData, ThrowOnError>) => (options.client ?? client).get<GetInvitationInfoApiV1OrganizationsInvitationsTokenGetResponses, GetInvitationInfoApiV1OrganizationsInvitationsTokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/organizations/invitations/{token}',
    ...options
});

/**
 * Resend Invitation
 *
 * Переотправка приглашения пользователю
 */
export const resendInvitationApiV1OrganizationsOrgIdMembersResendInvitePost = <ThrowOnError extends boolean = false>(options: Options<ResendInvitationApiV1OrganizationsOrgIdMembersResendInvitePostData, ThrowOnError>) => (options.client ?? client).post<ResendInvitationApiV1OrganizationsOrgIdMembersResendInvitePostResponses, ResendInvitationApiV1OrganizationsOrgIdMembersResendInvitePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/members/resend-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pending Invitations
 *
 * Получение списка приглашенных
 */
export const getPendingInvitationsApiV1OrganizationsOrgIdMembersPendingGet = <ThrowOnError extends boolean = false>(options: Options<GetPendingInvitationsApiV1OrganizationsOrgIdMembersPendingGetData, ThrowOnError>) => (options.client ?? client).get<GetPendingInvitationsApiV1OrganizationsOrgIdMembersPendingGetResponses, GetPendingInvitationsApiV1OrganizationsOrgIdMembersPendingGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/members/pending',
    ...options
});

/**
 * Revoke Invitation
 *
 * Отзыв неподтвержденного приглашения
 */
export const revokeInvitationApiV1OrganizationsOrgIdInvitationsMembershipIdDelete = <ThrowOnError extends boolean = false>(options: Options<RevokeInvitationApiV1OrganizationsOrgIdInvitationsMembershipIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<RevokeInvitationApiV1OrganizationsOrgIdInvitationsMembershipIdDeleteResponses, RevokeInvitationApiV1OrganizationsOrgIdInvitationsMembershipIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/invitations/{membership_id}',
    ...options
});

/**
 * Validate Invitation Token
 *
 * Валидация токена приглашения
 *
 * Проверяет валидность токена и возвращает полную информацию о приглашении,
 * включая статус пользователя и организации.
 *
 * Возвращает:
 * - is_valid: валиден ли токен
 * - email: email из приглашения (если токен валиден)
 * - org_id: ID организации (если токен валиден)
 * - organization_name: название организации (если токен валиден)
 * - user_exists: существует ли пользователь в системе
 * - user_registered: зарегистрирован ли пользователь
 * - user_verified: подтвержден ли email пользователя
 * - expires_at: дата истечения приглашения
 * - is_expired: истекло ли приглашение
 * - error_reason: причина невалидности (если токен невалиден)
 *
 * В случае невалидного токена все поля кроме is_valid и error_reason будут None
 */
export const validateInvitationTokenApiV1OrganizationsInvitationsTokenValidateGet = <ThrowOnError extends boolean = false>(options: Options<ValidateInvitationTokenApiV1OrganizationsInvitationsTokenValidateGetData, ThrowOnError>) => (options.client ?? client).get<ValidateInvitationTokenApiV1OrganizationsInvitationsTokenValidateGetResponses, ValidateInvitationTokenApiV1OrganizationsInvitationsTokenValidateGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/organizations/invitations/{token}/validate',
    ...options
});

/**
 * Upload Logo
 *
 * Обновление аватара пользователя
 */
export const uploadLogoApiV1OrganizationsOrgIdLogoUploadPost = <ThrowOnError extends boolean = false>(options: Options<UploadLogoApiV1OrganizationsOrgIdLogoUploadPostData, ThrowOnError>) => (options.client ?? client).post<UploadLogoApiV1OrganizationsOrgIdLogoUploadPostResponses, UploadLogoApiV1OrganizationsOrgIdLogoUploadPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/logo/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete User Avatar
 */
export const deleteUserAvatarApiV1OrganizationsOrgIdLogoDeleteDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteUserAvatarApiV1OrganizationsOrgIdLogoDeleteDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserAvatarApiV1OrganizationsOrgIdLogoDeleteDeleteResponses, DeleteUserAvatarApiV1OrganizationsOrgIdLogoDeleteDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/logo/delete',
    ...options
});

/**
 * Get Products List
 *
 * Получение списка товаров из Ozon
 *
 * Возвращает унифицированный список товаров с базовой информацией или с деталями.
 */
export const getProductsListApiV1ProductsOzonListIntegrationIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProductsListApiV1ProductsOzonListIntegrationIdGetData, ThrowOnError>) => (options.client ?? client).get<GetProductsListApiV1ProductsOzonListIntegrationIdGetResponses, GetProductsListApiV1ProductsOzonListIntegrationIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/ozon/list/{integration_id}',
    ...options
});

/**
 * Create Project Products Ozon
 *
 * Создание товаров проекта маркетплейс ozon
 */
export const createProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdPost = <ThrowOnError extends boolean = false>(options: Options<CreateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdPostData, ThrowOnError>) => (options.client ?? client).post<CreateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdPostResponses, CreateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/ozon/products/{integration_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Project Products Ozon
 *
 * Обновление товаров проекта маркетплейс ozon
 */
export const updateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdUpdatePost = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdUpdatePostData, ThrowOnError>) => (options.client ?? client).post<UpdateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdUpdatePostResponses, UpdateProjectProductsOzonApiV1ProductsOzonProductsIntegrationIdUpdatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/ozon/products/{integration_id}/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Wb Products
 *
 * GET версия эндпоинта для получения товаров Wildberries с query параметрами
 */
export const getWbProductsApiV1ProductsWildberriesListIntegrationIdGet = <ThrowOnError extends boolean = false>(options: Options<GetWbProductsApiV1ProductsWildberriesListIntegrationIdGetData, ThrowOnError>) => (options.client ?? client).get<GetWbProductsApiV1ProductsWildberriesListIntegrationIdGetResponses, GetWbProductsApiV1ProductsWildberriesListIntegrationIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/wildberries/list/{integration_id}',
    ...options
});

/**
 * Create Project Products Wildberries
 *
 * Создание товаров проекта маркетплейс wildberries
 */
export const createProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdPost = <ThrowOnError extends boolean = false>(options: Options<CreateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdPostData, ThrowOnError>) => (options.client ?? client).post<CreateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdPostResponses, CreateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/wildberries/products/{integration_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Project Products Wildberries
 *
 * Обновление товаров проекта маркетплейс wildberries
 */
export const updateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdUpdatePost = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdUpdatePostData, ThrowOnError>) => (options.client ?? client).post<UpdateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdUpdatePostResponses, UpdateProjectProductsWildberriesApiV1ProductsWildberriesProductsIntegrationIdUpdatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/wildberries/products/{integration_id}/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Project Products
 *
 * Получение списка товаров проекта
 */
export const getProjectProductsApiV1ProductsOrgIdListGet = <ThrowOnError extends boolean = false>(options: Options<GetProjectProductsApiV1ProductsOrgIdListGetData, ThrowOnError>) => (options.client ?? client).get<GetProjectProductsApiV1ProductsOrgIdListGetResponses, GetProjectProductsApiV1ProductsOrgIdListGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/list',
    ...options
});

/**
 * Create Project Product
 *
 * Создание товара проекта пользователем
 */
export const createProjectProductApiV1ProductsOrgIdCreatePost = <ThrowOnError extends boolean = false>(options: Options<CreateProjectProductApiV1ProductsOrgIdCreatePostData, ThrowOnError>) => (options.client ?? client).post<CreateProjectProductApiV1ProductsOrgIdCreatePostResponses, CreateProjectProductApiV1ProductsOrgIdCreatePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/create',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Product
 *
 * Удаление товара
 */
export const deleteProductApiV1ProductsOrgIdProductsProductIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteProductApiV1ProductsOrgIdProductsProductIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteProductApiV1ProductsOrgIdProductsProductIdDeleteResponses, DeleteProductApiV1ProductsOrgIdProductsProductIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/products/{product_id}',
    ...options
});

/**
 * Get Product Detail
 *
 * Получение деталей товара проекта
 */
export const getProductDetailApiV1ProductsOrgIdProductsProductIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProductDetailApiV1ProductsOrgIdProductsProductIdGetData, ThrowOnError>) => (options.client ?? client).get<GetProductDetailApiV1ProductsOrgIdProductsProductIdGetResponses, GetProductDetailApiV1ProductsOrgIdProductsProductIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/products/{product_id}',
    ...options
});

/**
 * Update Product
 *
 * Обновление товара проекта
 */
export const updateProductApiV1ProductsOrgIdProductsProductIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateProductApiV1ProductsOrgIdProductsProductIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateProductApiV1ProductsOrgIdProductsProductIdPutResponses, UpdateProductApiV1ProductsOrgIdProductsProductIdPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/products/{product_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Product Brends
 *
 * Список брендов организации
 */
export const getProductBrendsApiV1ProductsOrgIdBrandsGet = <ThrowOnError extends boolean = false>(options: Options<GetProductBrendsApiV1ProductsOrgIdBrandsGetData, ThrowOnError>) => (options.client ?? client).get<GetProductBrendsApiV1ProductsOrgIdBrandsGetResponses, GetProductBrendsApiV1ProductsOrgIdBrandsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/brands',
    ...options
});

/**
 * Create Product Brand
 *
 * Создание бренда товара
 */
export const createProductBrandApiV1ProductsOrgIdBrandsPost = <ThrowOnError extends boolean = false>(options: Options<CreateProductBrandApiV1ProductsOrgIdBrandsPostData, ThrowOnError>) => (options.client ?? client).post<CreateProductBrandApiV1ProductsOrgIdBrandsPostResponses, CreateProductBrandApiV1ProductsOrgIdBrandsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/brands',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Product Brend
 *
 * Удаление бренда товара
 */
export const deleteProductBrendApiV1ProductsOrgIdBrandsBrendIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteProductBrendApiV1ProductsOrgIdBrandsBrendIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteProductBrendApiV1ProductsOrgIdBrandsBrendIdDeleteResponses, DeleteProductBrendApiV1ProductsOrgIdBrandsBrendIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/brands/{brend_id}',
    ...options
});

/**
 * Get Product Brend
 *
 * Детали бренда товара
 */
export const getProductBrendApiV1ProductsOrgIdBrandsBrendIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProductBrendApiV1ProductsOrgIdBrandsBrendIdGetData, ThrowOnError>) => (options.client ?? client).get<GetProductBrendApiV1ProductsOrgIdBrandsBrendIdGetResponses, GetProductBrendApiV1ProductsOrgIdBrandsBrendIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/brands/{brend_id}',
    ...options
});

/**
 * Update Product Brend
 *
 * Обновление бренда товара
 */
export const updateProductBrendApiV1ProductsOrgIdBrandsBrendIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateProductBrendApiV1ProductsOrgIdBrandsBrendIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateProductBrendApiV1ProductsOrgIdBrandsBrendIdPutResponses, UpdateProductBrendApiV1ProductsOrgIdBrandsBrendIdPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/brands/{brend_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Product Sellers
 *
 * Список продавцов организации
 */
export const getProductSellersApiV1ProductsOrgIdSellersGet = <ThrowOnError extends boolean = false>(options: Options<GetProductSellersApiV1ProductsOrgIdSellersGetData, ThrowOnError>) => (options.client ?? client).get<GetProductSellersApiV1ProductsOrgIdSellersGetResponses, GetProductSellersApiV1ProductsOrgIdSellersGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/products/{org_id}/sellers',
    ...options
});

/**
 * Upload File
 *
 * Загрузка файла
 */
export const uploadFileApiV1AssetsUploadPost = <ThrowOnError extends boolean = false>(options: Options<UploadFileApiV1AssetsUploadPostData, ThrowOnError>) => (options.client ?? client).post<UploadFileApiV1AssetsUploadPostResponses, UploadFileApiV1AssetsUploadPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Assets
 *
 * Получение списка ассетов пользователя
 */
export const getAssetsApiV1AssetsGet = <ThrowOnError extends boolean = false>(options?: Options<GetAssetsApiV1AssetsGetData, ThrowOnError>) => (options?.client ?? client).get<GetAssetsApiV1AssetsGetResponses, GetAssetsApiV1AssetsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/',
    ...options
});

/**
 * Delete Asset
 *
 * Удаление ассета
 */
export const deleteAssetApiV1AssetsAssetIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteAssetApiV1AssetsAssetIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteAssetApiV1AssetsAssetIdDeleteResponses, DeleteAssetApiV1AssetsAssetIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{asset_id}',
    ...options
});

/**
 * Get Asset
 *
 * Получение ассета по ID
 */
export const getAssetApiV1AssetsAssetIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAssetApiV1AssetsAssetIdGetData, ThrowOnError>) => (options.client ?? client).get<GetAssetApiV1AssetsAssetIdGetResponses, GetAssetApiV1AssetsAssetIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{asset_id}',
    ...options
});

/**
 * Download Asset
 *
 * Скачивание файла ассета
 */
export const downloadAssetApiV1AssetsAssetIdDownloadGet = <ThrowOnError extends boolean = false>(options: Options<DownloadAssetApiV1AssetsAssetIdDownloadGetData, ThrowOnError>) => (options.client ?? client).get<DownloadAssetApiV1AssetsAssetIdDownloadGetResponses, DownloadAssetApiV1AssetsAssetIdDownloadGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{asset_id}/download',
    ...options
});

/**
 * Get Thumbnail
 *
 * Получение превью изображения
 */
export const getThumbnailApiV1AssetsAssetIdThumbnailGet = <ThrowOnError extends boolean = false>(options: Options<GetThumbnailApiV1AssetsAssetIdThumbnailGetData, ThrowOnError>) => (options.client ?? client).get<GetThumbnailApiV1AssetsAssetIdThumbnailGetResponses, GetThumbnailApiV1AssetsAssetIdThumbnailGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{asset_id}/thumbnail',
    ...options
});

/**
 * Optimize Image
 *
 * Оптимизация изображения
 */
export const optimizeImageApiV1AssetsAssetIdOptimizePost = <ThrowOnError extends boolean = false>(options: Options<OptimizeImageApiV1AssetsAssetIdOptimizePostData, ThrowOnError>) => (options.client ?? client).post<OptimizeImageApiV1AssetsAssetIdOptimizePostResponses, OptimizeImageApiV1AssetsAssetIdOptimizePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{asset_id}/optimize',
    ...options
});

/**
 * Get Assets Stats
 *
 * Получение статистики по ассетам пользователя
 */
export const getAssetsStatsApiV1AssetsStatsSummaryGet = <ThrowOnError extends boolean = false>(options?: Options<GetAssetsStatsApiV1AssetsStatsSummaryGetData, ThrowOnError>) => (options?.client ?? client).get<GetAssetsStatsApiV1AssetsStatsSummaryGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/stats/summary',
    ...options
});

/**
 * Get Product Assets
 *
 * Возвращает ассеты товар
 */
export const getProductAssetsApiV1AssetsOrgIdProductsProductIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProductAssetsApiV1AssetsOrgIdProductsProductIdGetData, ThrowOnError>) => (options.client ?? client).get<GetProductAssetsApiV1AssetsOrgIdProductsProductIdGetResponses, GetProductAssetsApiV1AssetsOrgIdProductsProductIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{org_id}/products/{product_id}',
    ...options
});

/**
 * Upload Product Asset
 *
 * Загрузка файлов товара
 */
export const uploadProductAssetApiV1AssetsOrgIdProductsProductIdPost = <ThrowOnError extends boolean = false>(options: Options<UploadProductAssetApiV1AssetsOrgIdProductsProductIdPostData, ThrowOnError>) => (options.client ?? client).post<UploadProductAssetApiV1AssetsOrgIdProductsProductIdPostResponses, UploadProductAssetApiV1AssetsOrgIdProductsProductIdPostErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{org_id}/products/{product_id}',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Delete Product Asset
 *
 * Удаление ассета товара
 */
export const deleteProductAssetApiV1AssetsOrgIdProductsProductAssetIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteProductAssetApiV1AssetsOrgIdProductsProductAssetIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteProductAssetApiV1AssetsOrgIdProductsProductAssetIdDeleteResponses, DeleteProductAssetApiV1AssetsOrgIdProductsProductAssetIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{org_id}/products/{product_asset_id}',
    ...options
});

/**
 * Analyze Product Content Competition
 *
 * Анализ контента товара конкурентов
 */
export const analyzeProductContentCompetitionApiV1GenerationsOrgIdValidateProductCompetitionPost = <ThrowOnError extends boolean = false>(options: Options<AnalyzeProductContentCompetitionApiV1GenerationsOrgIdValidateProductCompetitionPostData, ThrowOnError>) => (options.client ?? client).post<AnalyzeProductContentCompetitionApiV1GenerationsOrgIdValidateProductCompetitionPostResponses, AnalyzeProductContentCompetitionApiV1GenerationsOrgIdValidateProductCompetitionPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/validate-product/competition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Analyze Product Content
 *
 * Анализ контента товара с ContentAnalyzerAgent
 */
export const analyzeProductContentApiV1GenerationsOrgIdValidateProductProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<AnalyzeProductContentApiV1GenerationsOrgIdValidateProductProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<AnalyzeProductContentApiV1GenerationsOrgIdValidateProductProductProductIdPostResponses, AnalyzeProductContentApiV1GenerationsOrgIdValidateProductProductProductIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/validate-product/product/{product_id}',
    ...options
});

/**
 * Generate Title Description
 *
 * Генерация заголовка товара конкурента
 */
export const generateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<GenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<GenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPostResponses, GenerateTitleDescriptionApiV1GenerationsOrgIdGenerateTitleProductProductIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-title/product/{product_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Hp Image
 *
 * Генерация hero packshot изображения товара
 */
export const generateHpImageApiV1GenerationsOrgIdGenerateHpImageProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<GenerateHpImageApiV1GenerationsOrgIdGenerateHpImageProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<GenerateHpImageApiV1GenerationsOrgIdGenerateHpImageProductProductIdPostResponses, GenerateHpImageApiV1GenerationsOrgIdGenerateHpImageProductProductIdPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-hp-image/product/{product_id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Generate Ls Prompt
 *
 * Генерация промта для life style изображения конкурентов
 */
export const generateLsPromptApiV1GenerationsOrgIdGenerateLsPromptProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<GenerateLsPromptApiV1GenerationsOrgIdGenerateLsPromptProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<GenerateLsPromptApiV1GenerationsOrgIdGenerateLsPromptProductProductIdPostResponses, GenerateLsPromptApiV1GenerationsOrgIdGenerateLsPromptProductProductIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-ls-prompt/product/{product_id}',
    ...options
});

/**
 * Generate Ls Image
 *
 * Генерация life style изображения
 */
export const generateLsImageApiV1GenerationsOrgIdGenerateLsImageProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<GenerateLsImageApiV1GenerationsOrgIdGenerateLsImageProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<GenerateLsImageApiV1GenerationsOrgIdGenerateLsImageProductProductIdPostResponses, GenerateLsImageApiV1GenerationsOrgIdGenerateLsImageProductProductIdPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-ls-image/product/{product_id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Generate Ig Image
 *
 * Генерация изображения инфографики
 */
export const generateIgImageApiV1GenerationsOrgIdGenerateIgImageProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<GenerateIgImageApiV1GenerationsOrgIdGenerateIgImageProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<GenerateIgImageApiV1GenerationsOrgIdGenerateIgImageProductProductIdPostResponses, GenerateIgImageApiV1GenerationsOrgIdGenerateIgImageProductProductIdPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-ig-image/product/{product_id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Generate Product Group Images
 *
 * Генерация группы изображения для товара
 */
export const generateProductGroupImagesApiV1GenerationsOrgIdGenerateGroupImagesProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<GenerateProductGroupImagesApiV1GenerationsOrgIdGenerateGroupImagesProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<GenerateProductGroupImagesApiV1GenerationsOrgIdGenerateGroupImagesProductProductIdPostResponses, GenerateProductGroupImagesApiV1GenerationsOrgIdGenerateGroupImagesProductProductIdPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-group-images/product/{product_id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Generate Images
 *
 * Генерация группы изображения для товара
 */
export const generateImagesApiV1GenerationsOrgIdGenerateImagesProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<GenerateImagesApiV1GenerationsOrgIdGenerateImagesProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<GenerateImagesApiV1GenerationsOrgIdGenerateImagesProductProductIdPostResponses, GenerateImagesApiV1GenerationsOrgIdGenerateImagesProductProductIdPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-images/product/{product_id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Modify Images
 *
 * Изменение изображеня
 */
export const modifyImagesApiV1GenerationsOrgIdModifyImagesProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<ModifyImagesApiV1GenerationsOrgIdModifyImagesProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<ModifyImagesApiV1GenerationsOrgIdModifyImagesProductProductIdPostResponses, ModifyImagesApiV1GenerationsOrgIdModifyImagesProductProductIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/modify-images/product/{product_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenerate Images
 *
 * Обработчик перегенерации изображений
 */
export const regenerateImagesApiV1GenerationsOrgIdRegenerateImagesProductProductIdPost = <ThrowOnError extends boolean = false>(options: Options<RegenerateImagesApiV1GenerationsOrgIdRegenerateImagesProductProductIdPostData, ThrowOnError>) => (options.client ?? client).post<RegenerateImagesApiV1GenerationsOrgIdRegenerateImagesProductProductIdPostResponses, RegenerateImagesApiV1GenerationsOrgIdRegenerateImagesProductProductIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/regenerate_images/product/{product_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Generate Images Categories
 */
export const getGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGetResponses, GetGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-images/categories',
    ...options
});

/**
 * Get Generate Images Variants
 */
export const getGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGetResponses, GetGenerateImagesVariantsApiV1GenerationsOrgIdGenerateImagesCategoriesCategoryIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generate-images/categories/{category_id}',
    ...options
});

/**
 * Get Generation Status
 *
 * Получение статуса генерации из БД
 */
export const getGenerationStatusApiV1GenerationsGenerationGenerationIdStatusGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerationStatusApiV1GenerationsGenerationGenerationIdStatusGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerationStatusApiV1GenerationsGenerationGenerationIdStatusGetResponses, GetGenerationStatusApiV1GenerationsGenerationGenerationIdStatusGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/generation/{generation_id}/status',
    ...options
});

/**
 * Cancel Generation Endpoint
 *
 * Отмена генерации
 */
export const cancelGenerationEndpointApiV1GenerationsGenerationGenerationIdCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelGenerationEndpointApiV1GenerationsGenerationGenerationIdCancelPostData, ThrowOnError>) => (options.client ?? client).post<CancelGenerationEndpointApiV1GenerationsGenerationGenerationIdCancelPostResponses, CancelGenerationEndpointApiV1GenerationsGenerationGenerationIdCancelPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/generation/{generation_id}/cancel',
    ...options
});

/**
 * Get Product Generations
 *
 * Получение списка генераций товара с фильтрами
 */
export const getProductGenerationsApiV1GenerationsOrgIdProductProductIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProductGenerationsApiV1GenerationsOrgIdProductProductIdGetData, ThrowOnError>) => (options.client ?? client).get<GetProductGenerationsApiV1GenerationsOrgIdProductProductIdGetResponses, GetProductGenerationsApiV1GenerationsOrgIdProductProductIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/product/{product_id}',
    ...options
});

/**
 * Get Generation Stats
 *
 * Получение статистики генераций пользователя
 */
export const getGenerationStatsApiV1GenerationsStatsGet = <ThrowOnError extends boolean = false>(options?: Options<GetGenerationStatsApiV1GenerationsStatsGetData, ThrowOnError>) => (options?.client ?? client).get<GetGenerationStatsApiV1GenerationsStatsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/stats',
    ...options
});

/**
 * Get Background Removal Detail
 *
 * Детали генерации удаления фона
 */
export const getBackgroundRemovalDetailApiV1GenerationsGenerationGenerationIdBackgroundRemovalGet = <ThrowOnError extends boolean = false>(options: Options<GetBackgroundRemovalDetailApiV1GenerationsGenerationGenerationIdBackgroundRemovalGetData, ThrowOnError>) => (options.client ?? client).get<GetBackgroundRemovalDetailApiV1GenerationsGenerationGenerationIdBackgroundRemovalGetResponses, GetBackgroundRemovalDetailApiV1GenerationsGenerationGenerationIdBackgroundRemovalGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/generation/{generation_id}/background-removal',
    ...options
});

/**
 * Get Background Replacement Detail
 *
 * Детали генерации замены фона
 */
export const getBackgroundReplacementDetailApiV1GenerationsOrgIdGenerationGenerationIdBackgroundReplacementGet = <ThrowOnError extends boolean = false>(options: Options<GetBackgroundReplacementDetailApiV1GenerationsOrgIdGenerationGenerationIdBackgroundReplacementGetData, ThrowOnError>) => (options.client ?? client).get<GetBackgroundReplacementDetailApiV1GenerationsOrgIdGenerationGenerationIdBackgroundReplacementGetResponses, GetBackgroundReplacementDetailApiV1GenerationsOrgIdGenerationGenerationIdBackgroundReplacementGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation/{generation_id}/background-replacement',
    ...options
});

/**
 * Get Image Validation Detail
 *
 * Детали валидации изображения
 */
export const getImageValidationDetailApiV1GenerationsGenerationGenerationIdImageValidationGet = <ThrowOnError extends boolean = false>(options: Options<GetImageValidationDetailApiV1GenerationsGenerationGenerationIdImageValidationGetData, ThrowOnError>) => (options.client ?? client).get<GetImageValidationDetailApiV1GenerationsGenerationGenerationIdImageValidationGetResponses, GetImageValidationDetailApiV1GenerationsGenerationGenerationIdImageValidationGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/generation/{generation_id}/image-validation',
    ...options
});

/**
 * Get Card Validation Detail
 *
 * Детали валидации карточки товара
 */
export const getCardValidationDetailApiV1GenerationsOrgIdGenerationGenerationIdCardValidationGet = <ThrowOnError extends boolean = false>(options: Options<GetCardValidationDetailApiV1GenerationsOrgIdGenerationGenerationIdCardValidationGetData, ThrowOnError>) => (options.client ?? client).get<GetCardValidationDetailApiV1GenerationsOrgIdGenerationGenerationIdCardValidationGetResponses, GetCardValidationDetailApiV1GenerationsOrgIdGenerationGenerationIdCardValidationGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation/{generation_id}/card-validation',
    ...options
});

/**
 * Get Generate Title Detail
 *
 * Детали генерации заголовка и описания карточки товара
 */
export const getGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGetResponses, GetGenerateTitleDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateTitleGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation/{generation_id}/generate-title',
    ...options
});

/**
 * Get Generate Hp Image Detail
 *
 * Детали генерации hero packshot изображения
 */
export const getGenerateHpImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateHpImageGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerateHpImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateHpImageGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerateHpImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateHpImageGetResponses, GetGenerateHpImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateHpImageGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation/{generation_id}/generate-hp-image',
    ...options
});

/**
 * Get Generate Ls Prompt Detail
 *
 * Детали генерации промпт для life style изображения
 */
export const getGenerateLsPromptDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsPromptGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerateLsPromptDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsPromptGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerateLsPromptDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsPromptGetResponses, GetGenerateLsPromptDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsPromptGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation/{generation_id}/generate-ls-prompt',
    ...options
});

/**
 * Get Generate Ls Image Detail
 *
 * Детали генерации life style изображения
 */
export const getGenerateLsImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsImageGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerateLsImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsImageGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerateLsImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsImageGetResponses, GetGenerateLsImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateLsImageGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation/{generation_id}/generate-ls-image',
    ...options
});

/**
 * Get Generate Ig Image Detail
 *
 * Детали генерации изображения инфографики
 */
export const getGenerateIgImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateIgImageGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerateIgImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateIgImageGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerateIgImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateIgImageGetResponses, GetGenerateIgImageDetailApiV1GenerationsOrgIdGenerationGenerationIdGenerateIgImageGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation/{generation_id}/generate-ig-image',
    ...options
});

/**
 * Get Image Generation Groups
 *
 * Возвращает список групп генераций изображений
 */
export const getImageGenerationGroupsApiV1GenerationsOrgIdGenerationImageGroupsProductProductIdGet = <ThrowOnError extends boolean = false>(options: Options<GetImageGenerationGroupsApiV1GenerationsOrgIdGenerationImageGroupsProductProductIdGetData, ThrowOnError>) => (options.client ?? client).get<GetImageGenerationGroupsApiV1GenerationsOrgIdGenerationImageGroupsProductProductIdGetResponses, GetImageGenerationGroupsApiV1GenerationsOrgIdGenerationImageGroupsProductProductIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation-image-groups/product/{product_id}',
    ...options
});

/**
 * Get Generation Group Detail
 *
 * Детали группы генераций
 */
export const getGenerationGroupDetailApiV1GenerationsOrgIdGenerationImageGroupsGenerationGroupIdGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerationGroupDetailApiV1GenerationsOrgIdGenerationImageGroupsGenerationGroupIdGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerationGroupDetailApiV1GenerationsOrgIdGenerationImageGroupsGenerationGroupIdGetResponses, GetGenerationGroupDetailApiV1GenerationsOrgIdGenerationImageGroupsGenerationGroupIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation-image-groups/{generation_group_id}',
    ...options
});

/**
 * Update Generation Group
 *
 * Обновление группы генераций
 */
export const updateGenerationGroupApiV1GenerationsOrgIdGenerationGroupsGenerationGroupIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateGenerationGroupApiV1GenerationsOrgIdGenerationGroupsGenerationGroupIdPutData, ThrowOnError>) => (options.client ?? client).put<UpdateGenerationGroupApiV1GenerationsOrgIdGenerationGroupsGenerationGroupIdPutResponses, UpdateGenerationGroupApiV1GenerationsOrgIdGenerationGroupsGenerationGroupIdPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation-groups/{generation_group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Generation Export
 *
 * Возвращает файл результатов генерации
 */
export const getGenerationExportApiV1GenerationsOrgIdGenerationGenerationIdExportGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerationExportApiV1GenerationsOrgIdGenerationGenerationIdExportGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerationExportApiV1GenerationsOrgIdGenerationGenerationIdExportGetResponses, GetGenerationExportApiV1GenerationsOrgIdGenerationGenerationIdExportGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generation/{generation_id}/export',
    ...options
});

/**
 * Get Generation Ro Re Export Excel
 *
 * Возвращает excel файл генераций проверки карточки товара ро ре
 */
export const getGenerationRoReExportExcelApiV1GenerationsOrgIdGenerationsExportExcelPost = <ThrowOnError extends boolean = false>(options: Options<GetGenerationRoReExportExcelApiV1GenerationsOrgIdGenerationsExportExcelPostData, ThrowOnError>) => (options.client ?? client).post<GetGenerationRoReExportExcelApiV1GenerationsOrgIdGenerationsExportExcelPostResponses, GetGenerationRoReExportExcelApiV1GenerationsOrgIdGenerationsExportExcelPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{org_id}/generations/export/excel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Generation Feedback
 *
 * Создание отзыва генерации
 */
export const createGenerationFeedbackApiV1GenerationsGenerationGenerationIdFeedbackPost = <ThrowOnError extends boolean = false>(options: Options<CreateGenerationFeedbackApiV1GenerationsGenerationGenerationIdFeedbackPostData, ThrowOnError>) => (options.client ?? client).post<CreateGenerationFeedbackApiV1GenerationsGenerationGenerationIdFeedbackPostResponses, CreateGenerationFeedbackApiV1GenerationsGenerationGenerationIdFeedbackPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/generation/{generation_id}/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Generation Celery Status
 *
 * Получение статуса Celery задачи по ID генерации
 */
export const getGenerationCeleryStatusApiV1GenerationsGenerationIdCeleryStatusGet = <ThrowOnError extends boolean = false>(options: Options<GetGenerationCeleryStatusApiV1GenerationsGenerationIdCeleryStatusGetData, ThrowOnError>) => (options.client ?? client).get<GetGenerationCeleryStatusApiV1GenerationsGenerationIdCeleryStatusGetResponses, GetGenerationCeleryStatusApiV1GenerationsGenerationIdCeleryStatusGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/generations/{generation_id}/celery-status',
    ...options
});

/**
 * Openai Webhook Response
 *
 * Обработка задачи ответа (response) openai
 */
export const openaiWebhookResponseApiV1AiOpenaiWebhookResponsePost = <ThrowOnError extends boolean = false>(options?: Options<OpenaiWebhookResponseApiV1AiOpenaiWebhookResponsePostData, ThrowOnError>) => (options?.client ?? client).post<OpenaiWebhookResponseApiV1AiOpenaiWebhookResponsePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai/openai/webhook/response',
    ...options
});

/**
 * Replicate Webhook Prediction
 *
 * Обработка задачи генерации replicate
 */
export const replicateWebhookPredictionApiV1AiReplicateWebhookPredictionPost = <ThrowOnError extends boolean = false>(options?: Options<ReplicateWebhookPredictionApiV1AiReplicateWebhookPredictionPostData, ThrowOnError>) => (options?.client ?? client).post<ReplicateWebhookPredictionApiV1AiReplicateWebhookPredictionPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ai/replicate/webhook/prediction',
    ...options
});

/**
 * Update Products
 */
export const updateProductsApiV1MarketplaceWildberriesUpdateProductsIntegrationIdPost = <ThrowOnError extends boolean = false>(options: Options<UpdateProductsApiV1MarketplaceWildberriesUpdateProductsIntegrationIdPostData, ThrowOnError>) => (options.client ?? client).post<UpdateProductsApiV1MarketplaceWildberriesUpdateProductsIntegrationIdPostResponses, UpdateProductsApiV1MarketplaceWildberriesUpdateProductsIntegrationIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/wildberries/update_products/{integration_id}',
    ...options
});

/**
 * Update Products
 */
export const updateProductsApiV1MarketplaceOzonUpdateProductsIntegrationIdPost = <ThrowOnError extends boolean = false>(options: Options<UpdateProductsApiV1MarketplaceOzonUpdateProductsIntegrationIdPostData, ThrowOnError>) => (options.client ?? client).post<UpdateProductsApiV1MarketplaceOzonUpdateProductsIntegrationIdPostResponses, UpdateProductsApiV1MarketplaceOzonUpdateProductsIntegrationIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/ozon/update_products/{integration_id}',
    ...options
});

/**
 * Get Marketplace Examples
 *
 * Возвращает список доступных примеров товаров маркетплесов
 */
export const getMarketplaceExamplesApiV1MarketplaceExamplesGet = <ThrowOnError extends boolean = false>(options?: Options<GetMarketplaceExamplesApiV1MarketplaceExamplesGetData, ThrowOnError>) => (options?.client ?? client).get<GetMarketplaceExamplesApiV1MarketplaceExamplesGetResponses, GetMarketplaceExamplesApiV1MarketplaceExamplesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/examples',
    ...options
});

/**
 * Get Celery Task Status
 *
 * Получение детальной информации о задаче Celery
 */
export const getCeleryTaskStatusApiV1CeleryTaskTaskIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCeleryTaskStatusApiV1CeleryTaskTaskIdGetData, ThrowOnError>) => (options.client ?? client).get<GetCeleryTaskStatusApiV1CeleryTaskTaskIdGetResponses, GetCeleryTaskStatusApiV1CeleryTaskTaskIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/celery/task/{task_id}',
    ...options
});

/**
 * Get Celery Stats
 *
 * Получение общей статистики Celery (только для администраторов)
 */
export const getCeleryStatsApiV1CeleryStatsGet = <ThrowOnError extends boolean = false>(options?: Options<GetCeleryStatsApiV1CeleryStatsGetData, ThrowOnError>) => (options?.client ?? client).get<GetCeleryStatsApiV1CeleryStatsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/celery/stats',
    ...options
});

/**
 * Revoke Celery Task
 *
 * Отмена задачи Celery
 */
export const revokeCeleryTaskApiV1CeleryTaskTaskIdRevokePost = <ThrowOnError extends boolean = false>(options: Options<RevokeCeleryTaskApiV1CeleryTaskTaskIdRevokePostData, ThrowOnError>) => (options.client ?? client).post<RevokeCeleryTaskApiV1CeleryTaskTaskIdRevokePostResponses, RevokeCeleryTaskApiV1CeleryTaskTaskIdRevokePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/celery/task/{task_id}/revoke',
    ...options
});

/**
 * Get Active Celery Tasks
 *
 * Получение списка активных задач Celery для текущего пользователя
 */
export const getActiveCeleryTasksApiV1CeleryActiveTasksGet = <ThrowOnError extends boolean = false>(options?: Options<GetActiveCeleryTasksApiV1CeleryActiveTasksGetData, ThrowOnError>) => (options?.client ?? client).get<GetActiveCeleryTasksApiV1CeleryActiveTasksGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/celery/active-tasks',
    ...options
});

/**
 * Get Organization Token Balance
 *
 * Получить баланс токенов организации
 */
export const getOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGet = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGetData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGetResponses, GetOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/balance',
    ...options
});

/**
 * Get Token Transactions
 *
 * Получить историю операций с токенами (начисления и списания)
 */
export const getTokenTransactionsApiV1BillingOrgIdBillingTransactionsGet = <ThrowOnError extends boolean = false>(options: Options<GetTokenTransactionsApiV1BillingOrgIdBillingTransactionsGetData, ThrowOnError>) => (options.client ?? client).get<GetTokenTransactionsApiV1BillingOrgIdBillingTransactionsGetResponses, GetTokenTransactionsApiV1BillingOrgIdBillingTransactionsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/transactions',
    ...options
});

/**
 * Get Payments History
 *
 * Получить историю платежей организации
 */
export const getPaymentsHistoryApiV1BillingOrgIdBillingPaymentsGet = <ThrowOnError extends boolean = false>(options: Options<GetPaymentsHistoryApiV1BillingOrgIdBillingPaymentsGetData, ThrowOnError>) => (options.client ?? client).get<GetPaymentsHistoryApiV1BillingOrgIdBillingPaymentsGetResponses, GetPaymentsHistoryApiV1BillingOrgIdBillingPaymentsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/payments',
    ...options
});

/**
 * Apply Promo Code
 *
 * Применить промокод к организации
 */
export const applyPromoCodeApiV1BillingOrgIdBillingPromoApplyPost = <ThrowOnError extends boolean = false>(options: Options<ApplyPromoCodeApiV1BillingOrgIdBillingPromoApplyPostData, ThrowOnError>) => (options.client ?? client).post<ApplyPromoCodeApiV1BillingOrgIdBillingPromoApplyPostResponses, ApplyPromoCodeApiV1BillingOrgIdBillingPromoApplyPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/promo/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Subscription Info
 *
 * Получить информацию о текущей подписке организации
 */
export const getSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGet = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGetData, ThrowOnError>) => (options.client ?? client).get<GetSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGetResponses, GetSubscriptionInfoApiV1BillingOrgIdBillingSubscriptionGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/subscription',
    ...options
});

/**
 * Get Subscription History
 *
 * Получить историю подписок организации
 */
export const getSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGet = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGetData, ThrowOnError>) => (options.client ?? client).get<GetSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGetResponses, GetSubscriptionHistoryApiV1BillingOrgIdBillingSubscriptionHistoryGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/subscription/history',
    ...options
});

/**
 * Cancel Subscription
 *
 * Отменить автопродление подписки
 */
export const cancelSubscriptionApiV1BillingOrgIdBillingSubscriptionCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelSubscriptionApiV1BillingOrgIdBillingSubscriptionCancelPostData, ThrowOnError>) => (options.client ?? client).post<CancelSubscriptionApiV1BillingOrgIdBillingSubscriptionCancelPostResponses, CancelSubscriptionApiV1BillingOrgIdBillingSubscriptionCancelPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/subscription/cancel',
    ...options
});

/**
 * Spend Tokens
 *
 * Списать токены у организации
 */
export const spendTokensApiV1BillingOrgIdBillingTokensSpendPost = <ThrowOnError extends boolean = false>(options: Options<SpendTokensApiV1BillingOrgIdBillingTokensSpendPostData, ThrowOnError>) => (options.client ?? client).post<SpendTokensApiV1BillingOrgIdBillingTokensSpendPostResponses, SpendTokensApiV1BillingOrgIdBillingTokensSpendPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/tokens/spend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Can Afford
 *
 * Проверить может ли организация позволить себе действие стоимостью N токенов
 */
export const checkCanAffordApiV1BillingOrgIdBillingCanAffordTokenCostGet = <ThrowOnError extends boolean = false>(options: Options<CheckCanAffordApiV1BillingOrgIdBillingCanAffordTokenCostGetData, ThrowOnError>) => (options.client ?? client).get<CheckCanAffordApiV1BillingOrgIdBillingCanAffordTokenCostGetResponses, CheckCanAffordApiV1BillingOrgIdBillingCanAffordTokenCostGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/{org_id}/billing/can-afford/{token_cost}',
    ...options
});

/**
 * Subscription Payment Page
 *
 * Страница оформления подписки с виджетом CloudPayments
 */
export const subscriptionPaymentPageApiV1CloudpaymentsSubscribeGet = <ThrowOnError extends boolean = false>(options: Options<SubscriptionPaymentPageApiV1CloudpaymentsSubscribeGetData, ThrowOnError>) => (options.client ?? client).get<SubscriptionPaymentPageApiV1CloudpaymentsSubscribeGetResponses, SubscriptionPaymentPageApiV1CloudpaymentsSubscribeGetErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cloudpayments/subscribe',
    ...options
});

/**
 * Webhook Check
 *
 * Check webhook - проверка перед оплатой
 */
export const webhookCheckApiV1CloudpaymentsWebhooksCloudpaymentsCheckPost = <ThrowOnError extends boolean = false>(options?: Options<WebhookCheckApiV1CloudpaymentsWebhooksCloudpaymentsCheckPostData, ThrowOnError>) => (options?.client ?? client).post<WebhookCheckApiV1CloudpaymentsWebhooksCloudpaymentsCheckPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/cloudpayments/webhooks/cloudpayments/check',
    ...options
});

/**
 * Webhook Pay
 *
 * Pay webhook - УСПЕШНАЯ оплата
 */
export const webhookPayApiV1CloudpaymentsWebhooksCloudpaymentsPayPost = <ThrowOnError extends boolean = false>(options?: Options<WebhookPayApiV1CloudpaymentsWebhooksCloudpaymentsPayPostData, ThrowOnError>) => (options?.client ?? client).post<WebhookPayApiV1CloudpaymentsWebhooksCloudpaymentsPayPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/cloudpayments/webhooks/cloudpayments/pay',
    ...options
});

/**
 * Webhook Fail
 *
 * Fail webhook - НЕУДАЧНАЯ оплата
 */
export const webhookFailApiV1CloudpaymentsWebhooksCloudpaymentsFailPost = <ThrowOnError extends boolean = false>(options?: Options<WebhookFailApiV1CloudpaymentsWebhooksCloudpaymentsFailPostData, ThrowOnError>) => (options?.client ?? client).post<WebhookFailApiV1CloudpaymentsWebhooksCloudpaymentsFailPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/cloudpayments/webhooks/cloudpayments/fail',
    ...options
});

/**
 * Get Subscription Info
 *
 * Получить информацию для оформления подписки
 */
export const getSubscriptionInfoApiV1CloudpaymentsSubscribeInfoGet = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionInfoApiV1CloudpaymentsSubscribeInfoGetData, ThrowOnError>) => (options.client ?? client).get<GetSubscriptionInfoApiV1CloudpaymentsSubscribeInfoGetResponses, GetSubscriptionInfoApiV1CloudpaymentsSubscribeInfoGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cloudpayments/subscribe/info',
    ...options
});

/**
 * Purchase Tokens Page
 *
 * Страница докупки дополнительных токенов
 */
export const purchaseTokensPageApiV1CloudpaymentsPurchaseTokensGet = <ThrowOnError extends boolean = false>(options: Options<PurchaseTokensPageApiV1CloudpaymentsPurchaseTokensGetData, ThrowOnError>) => (options.client ?? client).get<PurchaseTokensPageApiV1CloudpaymentsPurchaseTokensGetResponses, PurchaseTokensPageApiV1CloudpaymentsPurchaseTokensGetErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cloudpayments/purchase-tokens',
    ...options
});

/**
 * Get Support Requests
 *
 * Список запросов в поддержку пользователя
 */
export const getSupportRequestsApiV1SupportSupportRequestsGet = <ThrowOnError extends boolean = false>(options?: Options<GetSupportRequestsApiV1SupportSupportRequestsGetData, ThrowOnError>) => (options?.client ?? client).get<GetSupportRequestsApiV1SupportSupportRequestsGetResponses, GetSupportRequestsApiV1SupportSupportRequestsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/support/support-requests',
    ...options
});

/**
 * Create Support Request
 *
 * Создание запроса в поддержку
 */
export const createSupportRequestApiV1SupportSupportRequestsPost = <ThrowOnError extends boolean = false>(options: Options<CreateSupportRequestApiV1SupportSupportRequestsPostData, ThrowOnError>) => (options.client ?? client).post<CreateSupportRequestApiV1SupportSupportRequestsPostResponses, CreateSupportRequestApiV1SupportSupportRequestsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/support/support-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Support Request
 *
 * Возвращает данные одного запроса в поддержку
 */
export const getSupportRequestApiV1SupportSupportRequestsSupportRequestIdGet = <ThrowOnError extends boolean = false>(options: Options<GetSupportRequestApiV1SupportSupportRequestsSupportRequestIdGetData, ThrowOnError>) => (options.client ?? client).get<GetSupportRequestApiV1SupportSupportRequestsSupportRequestIdGetResponses, GetSupportRequestApiV1SupportSupportRequestsSupportRequestIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/support/support-requests/{support_request_id',
    ...options
});

/**
 * Get Common Scores
 *
 * Общая статистика оценок проверок карточки товара
 */
export const getCommonScoresApiV1StatsOrgIdCommonGet = <ThrowOnError extends boolean = false>(options: Options<GetCommonScoresApiV1StatsOrgIdCommonGetData, ThrowOnError>) => (options.client ?? client).get<GetCommonScoresApiV1StatsOrgIdCommonGetResponses, GetCommonScoresApiV1StatsOrgIdCommonGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/stats/{org_id}/common',
    ...options
});

/**
 * Generation Score Stats
 *
 * Статистика проверок карточки товара
 */
export const generationScoreStatsApiV1StatsOrgIdScoresGet = <ThrowOnError extends boolean = false>(options: Options<GenerationScoreStatsApiV1StatsOrgIdScoresGetData, ThrowOnError>) => (options.client ?? client).get<GenerationScoreStatsApiV1StatsOrgIdScoresGetResponses, GenerationScoreStatsApiV1StatsOrgIdScoresGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/stats/{org_id}/scores',
    ...options
});

/**
 * Generation Segment Score Stats
 *
 * Статистика сегментов проверки карточки товаров
 */
export const generationSegmentScoreStatsApiV1StatsOrgIdSegmentScoresGet = <ThrowOnError extends boolean = false>(options: Options<GenerationSegmentScoreStatsApiV1StatsOrgIdSegmentScoresGetData, ThrowOnError>) => (options.client ?? client).get<GenerationSegmentScoreStatsApiV1StatsOrgIdSegmentScoresGetResponses, GenerationSegmentScoreStatsApiV1StatsOrgIdSegmentScoresGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/stats/{org_id}/segment-scores',
    ...options
});

/**
 * Get Top Bottom Products
 *
 * Список товаров с высокими и низкими оценками проверок
 */
export const getTopBottomProductsApiV1StatsOrgIdProductsGet = <ThrowOnError extends boolean = false>(options: Options<GetTopBottomProductsApiV1StatsOrgIdProductsGetData, ThrowOnError>) => (options.client ?? client).get<GetTopBottomProductsApiV1StatsOrgIdProductsGetResponses, GetTopBottomProductsApiV1StatsOrgIdProductsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/stats/{org_id}/products',
    ...options
});

/**
 * Get Products Scores
 *
 * Возвращает список оценок товаров
 */
export const getProductsScoresApiV1StatsOrgIdProductsScoresGet = <ThrowOnError extends boolean = false>(options: Options<GetProductsScoresApiV1StatsOrgIdProductsScoresGetData, ThrowOnError>) => (options.client ?? client).get<GetProductsScoresApiV1StatsOrgIdProductsScoresGetResponses, GetProductsScoresApiV1StatsOrgIdProductsScoresGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/stats/{org_id}/products-scores',
    ...options
});

/**
 * Health Check
 *
 * Проверка здоровья сервиса
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/health',
    ...options
});
